module.exports = __webpack_public_path__ + "img/795038_C2856B_533320_AC7C61-256px.c283c10c.png";